import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgNewHero',
})
export default class CmgNewHero extends Vue {
  interval: any;

   mounted() {
    this.interval = setInterval(this.resizeIframe, 1000);
  } 
  destroyed() {    
    clearInterval(this.interval);
  }
  get newHeroURL(): string {
    return `${window.location.origin}/content/experience-fragments/chipotle/new-hero-layouts/master.html`;
  }
  resizeIframe() {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    const iframeContainer = this.$refs.iframeContainer as HTMLElement;
    if (iframe && iframe.contentWindow) {
      const height = iframe.contentWindow.document.documentElement.offsetHeight + 'px';
      iframe.style.height = height;
      iframeContainer.style.height = height;
    }
  }
}
